__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/043fb587d15821163c6e7b0f443e8adaf9ca61b6/_next/";